import script from "./ChatModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatModal.vue?vue&type=script&lang=ts&setup=true"

import "./ChatModal.vue?vue&type=style&index=0&id=13906b72&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13906b72"]])

export default __exports__